<div [class.hover-scrollable]="scrollable" >
  <div [style.width]="width" [style.minWidth]="minWidth">
    <div class="{{styles}}">
      <ng-content></ng-content>
    </div>
  </div>
</div>